var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 5,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 19H10.75C9.234 19 8 17.7663 8 16.2506V11.9446C8 11.0298 8.453 10.178 9.212 9.66564L12.462 7.47314C13.3955 6.84229 14.604 6.84229 15.5385 7.47314L18.788 9.66564C19.547 10.1775 20 11.0298 20 11.9446V16.2506C20 17.7663 18.766 19 17.25 19ZM14 8.50091C13.757 8.50091 13.513 8.57289 13.3015 8.71636L10.051 10.9084C9.7065 11.1413 9.5 11.5282 9.5 11.9441V16.2501C9.5 16.9395 10.0605 17.4998 10.75 17.4998H17.25C17.9395 17.4998 18.5 16.9395 18.5 16.2501V11.9446C18.5 11.5287 18.294 11.1418 17.949 10.9089L14.699 8.71636C14.4865 8.57289 14.243 8.50091 14 8.50091Z",
    fill: "#09041C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.05791ab6c622c697ada7ca6a18f68bad.svg";
export { ForwardRef as ReactComponent };